import styles from './AddMaterialItem.module.css';
import InputForm from '../InputForm/InputForm';
import { SelectForm } from '../SelectForm/SelectForm';

export default function AddMaterialItem({ item, typesDict, onChange, onRemove }) {
	const brandOptions = (typesDict[String(item.material_type_id)]?.brands || []).map(b => ({ value: b, label: b }));
	const selectedBrand = brandOptions.find(o => o.value === item.brand) || null;

	const set = (name, value) => onChange({ ...item, [name]: value });

	const handleNumber = (e) => {
		const name = e.target.name;
		const raw = e.target.valueAsNumber ?? Number(e.target.value);
		set(name, Number.isFinite(raw) ? Math.max(1, Math.floor(raw)) : 1);
	};

	const normalizeNumber = (e) => {
		const name = e.target.name;
		const current = Number(item[name]);
		set(name, Number.isFinite(current) ? Math.max(1, Math.floor(current)) : 1);
	};

	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<span className={styles.title}>{item.title}</span>
				<button type="button" className={styles.remove} onClick={onRemove}>✕</button>
			</div>
			<div className={styles.fields}>
				<label className={`${styles.label} ${styles.narrow}`}>
					Кол-во:
					<InputForm value={item.quantity} type="number" name="quantity" min={1} step={1}
						onChange={handleNumber} onBlur={normalizeNumber} />
				</label>
				<label className={`${styles.label} ${styles.narrow}`}>
					Период, дн.:
					<InputForm value={item.period} type="number" name="period" min={1} step={1}
						onChange={handleNumber} onBlur={normalizeNumber} />
				</label>
				<label className={`${styles.label} ${styles.sertificate}`}>
					Сертификат:
					<InputForm value={item.sertificate || ''} type="text" name="sertificate"
						placeholder="Сертификат"
						onChange={e => set('sertificate', e.target.value)} />
				</label>
				<label className={`${styles.label} ${styles.brand}`}>
					Марка СИЗ:
					<SelectForm value={selectedBrand} options={brandOptions}
						placeholder="—" isClearable
						isDisabled={!brandOptions.length}
						menuPortalTarget={document.body}
						onChange={opt => set('brand', opt ? opt.value : null)} />
				</label>
			</div>
		</div>
	);
}